<template>
  <bom-tree-chart ref="bomTreeChart" class="app-container" />
</template>
<script>
import bomTreeChart from "@/components/production/craftsmanship/bom/bomTreeChart";
export default {
  name: "treechart",
  components: { bomTreeChart },
  methods: {},
};
</script>